import { ApiNotReadyError } from '@/features/api/error'
import { AxiosInstance, InternalAxiosRequestConfig } from 'axios'

export class ApiNotReadyInterceptor {
    constructor(
        private axiosInstance: AxiosInstance,
        private checkFn: () => boolean
    ) {
        this.attachInterceptor()
    }

    private attachInterceptor = (): void => {
        this.axiosInstance.interceptors.request.use(this.onBeforeRequestSent)
    }

    private onBeforeRequestSent = (
        config: InternalAxiosRequestConfig
    ): Promise<InternalAxiosRequestConfig> => {
        if (!this.checkFn()) {
            return Promise.reject(new ApiNotReadyError())
        }

        return Promise.resolve(config)
    }
}
